import { useState } from "react";
import { Button, Badge, Modal } from "react-bootstrap";
import { StarRating } from "./StarRating";

function InstructorPopup({ show, handleClose, course }) {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            size="md"
            contentClassName="border-0 shadow-lg"
        >
            <Modal.Body>
                {/* ── Instructor Header ── */}
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                    <div className="d-flex align-items-center gap-2">
                        <img
                            src={course.instructorImg}
                            alt={course.instructor}
                            className="rounded-circle flex-shrink-0 object-fit-cover"
                            width={40}
                            height={40}
                        />
                        <div className="flex-grow-1">
                            <div className="text-xs text-muted">Course by</div>
                            <div className="text-sm fw-medium text-dark">{course.instructor}</div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center gap-1">
                        <i className="bi bi-star-fill text-primary" />
                        <span className="fw-bold">{course.popRating}</span>
                        <span className="text-secondary text-xs">
                            ({course.popReviews})
                        </span>
                    </div>
                </div>

                <div className="d-flex flex-wrap align-items-center row-gap-1 column-gap-3 mb-3">
                    <span className="d-flex align-items-center gap-1 text-sm bg-success bg-opacity-10 text-success px-2 py-1 rounded">
                        <i className="bi bi-check-circle-fill" />
                        Professional
                    </span>
                    <span className="d-flex align-items-center gap-1 text-sm bg-primary bg-opacity-10 text-primary px-2 py-1 rounded">
                        <i className="bi bi-lightning-charge-fill" />
                        Super Tutor
                    </span>
                    <span className="ms-auto text-lg">🇮🇳</span>
                </div>

                {/* ── Price Section ── */}
                <div className="bg-secondary bg-opacity-10 border rounded-3 px-3 py-2 mb-3">
                    <div className="d-flex align-items-center gap-2 mb-2">
                        <span className="text-lg fw-bold text-dark mb-0">{course.popPrice}</span>
                        <span className="text-muted text-decoration-line-through small">{course.popOldPrice}</span>
                        <Badge bg="success" className="fw-medium ms-2">{course.discount}</Badge>
                    </div>
                    <p className="text-xs text-danger mb-0">Best price guaranteed for this instructor</p>
                </div>

                {/* ── Languages & Bio ── */}
                <div className="mb-3">
                    <div className="text-sm text-dark fw-medium mb-2">{course.speaks}</div>
                    <div className="text-sm text-secondary">
                        {course.bio}
                    </div>
                </div>

                {/* ── Popular Tag ── */}
                <div className="d-flex align-items-center gap-2 text-sm text-dark mb-4 py-2 border-top border-bottom">
                    <i className="bi bi-graph-up-arrow text-success" />
                    <span className="fw-medium">{course.popular}</span>
                </div>

                {/* ── CTAs ── */}
                <div className="d-flex flex-column gap-2">
                    <Button variant="primary" className="py-2" onClick={handleClose}>Book Trial Lesson</Button>
                    <Button variant="outline-secondary" className="py-2">Send Message</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

// CourseCardBox
export default function CourseCardBox({ course }) {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div className="bg-white border h-100 position-relative overflow-hidden">
                <img src={course.image} alt={course.image} className="img-fluid w-100 object-fit-cover" style={{ height: "170px" }} />
                <div className="item-info small">
                    <div className="flex-grow-1 p-3">
                        {/* Category + Price */}
                        <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
                            <span className={`course-category badge bg-${course.catColor} bg-opacity-10 fw-medium rounded-0 text-${course.catColor} text-uppercase`}>
                                {course.category}
                            </span>
                            <span className="course-price text-base fw-medium text-primary">{course.price}</span>
                        </div>

                        {/* Instructor Name */}
                        <div className="course-title text-base text-truncate mb-1">{course.instructor}</div>

                        {/* Role */}
                        <div className="text-secondary text-opacity-75 text-truncate">{course.role}</div>
                    </div>

                    {/* Rating + Students */}
                    <div className="border-top d-flex flex-wrap align-items-center justify-content-between gap-2 text-body px-3 py-2">
                        <span className="ratings d-flex align-items-center gap-1">
                            <StarRating rating={course.rating} />
                            <span className="rating-number">{course.rating.toFixed(1)}</span>
                        </span>
                        <span className="d-flex align-items-center gap-1 text-body">
                            <i className="bi bi-person text-base text-theme1" />
                            <span>{course.students}</span>
                            <span className="text-secondary text-opacity-75">students</span>
                        </span>
                    </div>
                </div>
                <span className="bg-primary position-absolute top-0 end-0 text-white text-sm d-flex align-items-center justify-content-center rounded-circle pointer m-2"
                    title="View Mentor Information"
                    onClick={() => setShowModal(true)}
                    style={{ width: '26px', height: '26px' }}
                >
                    <i className="bi bi-eye-fill"></i>
                </span>
            </div>

            {/* Instructor Modal */}
            <InstructorPopup
                show={showModal}
                handleClose={(e) => {
                    if (e) e.stopPropagation();
                    setShowModal(false);
                }}
                course={course}
            />
        </>
    );
}